<template>
     <el-dialog
        title="立即支付"
        :visible.sync="_value"
        @close="dialogClose"
        @open="dialogOpen"
        width="50%">
        <div style="text-align:center;margin-bottom:20px">
            <p style="font-size:20px;margin-bottom:20px;">
                支付金额
                <span style="color:#FF0000;font-size:24px;font-weight:bold">{{totalPrice ? (totalPrice / 100).toFixed(2) : 0}} 元</span>
            </p>
            <p style="font-size:24px;color:#333">{{payType == 'wechat_web' ? '微信扫码付款' : '支付宝扫码付款'}}</p>
            <img :src="paysrc" style="weight:50%">
        </div>
    </el-dialog>

</template>

<script>
   export default {
        mounted() {
            // this.chartTimeTypeChange()
        },
        props: {
            value:{
                type:Boolean,
                default:false
            },
            totalPrice:{
                type:Number,
                default: 0,
            },
            outTradeNo:{
                type:String,
                default: ''
            },
            paysrc:{
                type:String,
                default:''
            },
            payType:{
                type:String,
                default:'alipay'
            }
        },
        computed: {
            _value: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            },
        data: function() {
            return {
                timer:''
            };
        },
        watch: {
            
        },
        methods: {
            dialogClose(){
                clearInterval(this.timer)
            },
            dialogOpen(){
                this.timer = setInterval(this.getPayStatus, 1000)
            },
            getPayStatus() {
                this.$request('/v3/violation/order/poll',{
                    order_id: this.outTradeNo,
                }).then((xhr, res) => {
                    if (res.code == 0 && res.data == 1) {
                        this._value = false
                        clearInterval(this.timer)
                        this.$router.push({
                            path:'/success',
                            query: {
                                price: (this.totalPrice / 100).toFixed(2)
                            }
                        })
                    }
                    // else if(window.localStorage.UserTel && (window.localStorage.UserTel == '18072755357' || window.localStorage.UserTel == '15158027703')){
                    //     this._value = false
                    //     clearInterval(this.timer)
                    //     this.$router.push({
                    //         path:'/success',
                    //         query: {
                    //             price: (this.totalPrice / 100).toFixed(2)
                    //         }
                    //     })
                    // }
                });
            }
        }
    }

</script>

